export default __webpack_public_path__ + "static/media/continuous.41ffa5d2.png";